export default __webpack_public_path__ + "assets/img/kideco-logo.cbeb380712cf8f3f4fba25c443ed4d1a.svg";